import React from 'react';

import Modal from 'components/layout/Modal';

import { Props } from './index';
import StyledComponent from './styles';

const ProductBoxPayPoModal: React.FC<Props> = ({ onClose }): React.ReactElement => {
    return (
        <StyledComponent className="public-layout-product-box-paypo-modal">
            <Modal onClose={onClose}>
                <div className="paypo">
                    <dialog className="paypo__dialog">
                        <iframe
                            className="paypo__container"
                            src="https://popup.paypo.pl"
                            title="PayPo"
                        ></iframe>
                    </dialog>
                </div>
            </Modal>
        </StyledComponent>
    );
};

export default ProductBoxPayPoModal;